module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.77171d8f.ttf";